TS.ns('WL');

WL.leasingFacilitiesSelectModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config); 

        var facilitiesList = me.getDomainProperty('LeasingFacilitiesList_Property');
        if (facilitiesList) {

            facilitiesList.executeDefault = function () {
                var facilitiesList = me.getDomainProperty('LeasingFacilitiesList_Property');
                var FacilityId = facilitiesList.SelectedItem().FacilityId();
                var FacilitySiteId = facilitiesList.SelectedItem().FacilitySiteId();
                var FacilityNo = facilitiesList.SelectedItem().FacilityNo();
                me.performServerCommand('Save', true, { FacilityId: FacilityId,FacilitySiteId:FacilitySiteId, FacilityNo: FacilityNo });
            }
        }

    }
});